<template>
  <LoaderCar v-if="loading" width="600px" marginTop="0"/>
  <div class="code-agence" v-else>
    <Toast />
    <HeaderHome :user="this.$store.state.user.prenom"/>
    <div class="code-content">
      <div class="greeting">
        <p><span @click="goToHome" style="cursor:pointer">Accueil</span> > Code</p>
        <h1>Gestion Code</h1>
        <p>Liste des élèves et attribution des identifiants Prépacode</p>
      </div>
      <div class="informations">
        <div class="left">
          <div class="header-left">

            <div class="filtre livre" v-if="!showLivre" @click="showLivres">
              <span>{{ livretCount }}</span>
              <span>Livre à donner</span>
            </div>
            <div class="filtre livre-active" v-if="showLivre" @click="showLivres">
              <span>{{ livretCount }}</span>
              <span>Livre à donner</span>
            </div>

            <div class="filtre prepa" v-if="!showPrepaCode" @click="showPrepaCodes">
              <span>{{ PrepaCount }}</span>
              <span>PrepaCode à donner</span>
            </div>
            <div class="filtre prepa-active" v-if="showPrepaCode" @click="showPrepaCodes">
              <span>{{ PrepaCount }}</span>
              <span>PrepaCode à donner</span>
            </div>

            <div class="filtre archive" v-if="!showArchive" @click="showArchives">
              <span>{{ prepaArchive }}</span>
              <span>Archivés</span>
            </div>
            <div class="filtre archive-active" v-if="showArchive" @click="showArchives">
              <span>{{ prepaArchive }}</span>
              <span>Archivés</span>
            </div>
          </div>

          <div class="search-student">
            <SimpleTypeahead
              id="typeahead_id"
              :key="typeaheadKey"
              placeholder="Rechercher un élève..."
              :items="leleves"
              :minInputLength="1"
              :itemProjection="
                (item) => {
                  return item.fullname;
                }
              "
              @selectItem="selectItem"
              @onInput="searchEleve"
            >
            </SimpleTypeahead>
            <button class="cancel-select" v-if="showBtn" @click="cancelChoice">X</button>
          </div>

          <div class="tableau">
            <DataTable
              :value="students"
              sortMode="multiple"
              :rows="10"
              v-model:filters="filters"
              v-model:selection="selectedItem"
              selectionMode="single"
              filterDisplay="menu"
              responsiveLayout="scroll"
              dataKey="id"
              @click="onSelected"
              tableStyle="min-width: 50rem"
              :globalFilterFields="['nom', 'prenom', 'livret', 'prepacode', 'datep']"
            >
              <Column field="datep" header="Date" style="width: 25%" ></Column>
              <Column field="nom" header="Nom" style="width: 25%"></Column>
              
              <Column
                field="prenom"
                header="Prénom"
                style="width: 25%"
              ></Column>
              <Column
                field="livret"
                header="Livre de Code"
                style="width: 25%"
              >
                <template #body="slotProps">
                  <template v-if="slotProps.data.livret == null">
                    <button
                      class="btn btn-primary"
                      @click="postLivreCode(slotProps.data)"
                    >
                      Livre donné ?
                    </button>
                  </template>
                  <template v-else>
                    <button
                      class="btn btn-danger"
                      @click="cancelLivreCode(slotProps.data)"
                    >
                      Oui
                    </button>
                  </template>
                </template>
              </Column>
              <Column
                field="prepacode"
                header="Prepacode"
                style="width: 25%"
              >
                <template #body="slotProps">
                  <template v-if="slotProps.data.prepacode != null">
                    <button
                      class="btn btn-danger"
                      @click="deletePrepacode(slotProps.data)"
                    >
                      Oui
                    </button>
                  </template>
                </template>
              </Column>
            </DataTable>
            <Paginator v-model:first="currentPage" :rows="10" :totalRecords="studentsCount" @page="onPaginate"></Paginator>
          </div>

        </div>

        <div class="right not-select" v-if="selectedItem === null">
            <svg width="40" height="40" fill="none" viewBox="0 0 24 24" style="color:#94a3b8; margin-bottom: 12px">
              <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.5"/>
              <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <p>Cliquez sur un élève<br>pour afficher ses informations</p>
        </div>
        <div class="right" v-if="selectedItem != null">
          <div class="header-right">
            <p>{{ this.selectedItem.prenom }} {{ this.selectedItem.nom.toUpperCase() }}</p>
            <p>{{ this.selectedItem.tel }} - {{ this.selectedItem.mail }}</p>
            <div class="actions">
                <template v-if="this.selectedItem.newContract == 'null'">
                  <div class="contrat not">
                    CONTRAT NON CREE
                  </div>
                </template>
                <template v-if="this.selectedItem.newContract == 'wait'">
                  <div class="contrat wait">
                    CONTRAT EN ATTENTE
                  </div>
                </template>
                <template v-if="this.selectedItem.newContract == 'valide'">
                  <div class="contrat good">
                    CONTRAT ✓
                  </div>
                </template>
              <button v-if="!showPaiements" class="solde" @click="showPaiement">
                SOLDE
              </button>
              <button v-if="showPaiements" class="solde-cancel" @click="this.showPaiements = false;">
                X
              </button>
            </div>
          </div>

          <div class="content-right">
            <template v-if="!showPaiements">
              <p>IDENTIFIANTS PREPACODE</p>
              <input v-if="selectedItem.prepacode == null" type="text" name="id" id="id" placeholder="Identifiant.." v-model="selectedItem.identifiant" @input="selectedItem.password = selectedItem.identifiant">
              <input v-else type="text" name="id" id="id" placeholder="Identifiant.." v-model="selectedItem.prepacode[0].identifiant" @input="selectedItem.password = selectedItem.prepacode[0].identifiant">
              <input type="password" name="id" id="id" placeholder="mot de passe.." v-model="selectedItem.password" style="display:none">
              <div class="first">
                <button @click="postPrepacode(selectedItem)">VALIDER</button>
                <button v-if="selectedItem.prepacode != null && selectedItem.prepacode[0].status == 'ok'" @click="deletePrepacode(selectedItem)">SUPPRIMER</button>
              </div>
              <button class="send-id" v-if="selectedItem.prepacode != null && selectedItem.prepacode[0].status == 'ok'" @click="sendId(selectedItem)">✉ Envoyer les identifiants</button>
            </template>
            <template v-else>
              <paiement :data="selectedItem" :modal="false"/>
            </template>

            
          </div>

        </div>

      </div>
    </div>

  </div>
</template>
<script>
import HeaderHome from '../../components/home/HeaderHome.vue';
import SimpleTypeahead from "vue3-simple-typeahead";
import { FilterMatchMode } from "primevue/api";
import paiement from "@/components/eleve/Paiement.vue";
import { useToast } from "primevue/usetoast";
import LoaderCar from '../../components/LoaderCar.vue';

export default {

  components: {
    HeaderHome,
    SimpleTypeahead,
    paiement,
    LoaderCar
  },

  data() {
    return {
      studentsCount: 0,
      livretCount: 0,
      PrepaCount: 0,
      prepaArchive: 0,
      selectedItem: null,
      studentsUnArchive: [],
      studentsLivreCode: [],
      studentsPrepaCode: [],
      students: [],
      showForm: false,
      showArchive: false,
      showLivre: false,
      showPrepaCode: false,
      leleves : [],
      showBtn: false,
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      showPaiements : false,
      toast: useToast(),
      typeaheadKey: 0, 
      loading: true,
      currentPage: 0
    }
  },

  mounted() {
    this.getStudents(0, "null");
  },

  methods: {

    goToHome() {
      this.$router.push({ name: "Home" });
    },

    postPrepacode(student) {
      const date = new Date();
      let id = "";
      if (student.prepacode == null) {
        id = student.identifiant;
      } else {
        id = student.prepacode[0].identifiant;
      }

      window.api
        .post(
          "/code/prepacode/" + student.id,
          {
            delete : false,
            identifiant: id,
            password: student.password,
            datePrepaCode : date,
            archive : false
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then(() => {
          this.showArchive = false;
          this.showLivre = false;
          this.showPrepaCode = false;
          this.showBtn = false;
          this.leleves = [];
          this.currentPage = 0;
          this.getStudents(0, "null");
          // this.sendId(student); // envoi mail désactivé temporairement
          this.toast.add({
              severity: "success",
              summary: "ID Prepacode validé",
              life: 5000,
            });

        })
        .catch((error) => {
          console.log(error);
          this.toast.add({
              severity: "error",
              summary: "Une erreur est survenue",
              life: 3000,
            });

        });
    },

    deletePrepacode(student) {
      window.api
        .post(
          "/code/prepacode/" + student.id,
          {
            delete : true,
            identifiant: "null",
            password: "null",
            datePrepaCode : "null",
            archive : false
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then(() => {

          this.toast.add({
              severity: "success",
              summary: "ID Prepacode supprimé",
              life: 5000,
            });

          this.showArchive = false;
          this.showLivre = false;
          this.showPrepaCode = false;
          this.showBtn = false;
          this.leleves = [];
          this.currentPage = 0;
          this.getStudents(0, "null");
        })
        .catch((error) => {

          this.toast.add({
              severity: "error",
              summary: "Une erreur est survenue",
              life: 3000,
            });

          console.log(error);
        });
    },

    sendId(student){
      window.api
          .get("give/prepacode/" + student.id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then(() => {

            this.toast.add({
              severity: "info",
              summary: "ID Prepacode envoyé par mail",
              detail: "(vérifier les spams)",
              life: 3000,
            });

          })
          .catch((error) => {
            console.log(error);

            this.toast.add({
              severity: "error",
              summary: "Une erreur est survenue",
              life: 3000,
            });

          });
    },

    showPaiement(){
      this.showPaiements = true;
    },

    postLivreCode(student) {
      const date = new Date();

      if (student.livret == null && student.prepacode == null) {
        window.api
          .post(
            "/prepacodes",
            {
              utilisateur: "/api/utilisateurs/" + student.id,
              livret: date,
              archive : false,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then(() => {
            this.showArchive = false;
            this.showLivre = false;
            this.showPrepaCode = false;
            this.showBtn = false;
            this.leleves = [];
            this.currentPage = 0;
            this.getStudents(0, "null");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        window.api
          .patch(
            "/prepacodes/" + student.prepacode[0].id,
            {
              livret: date,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "application/merge-patch+json",
              },
            }
          )
          .then(() => {
            this.showArchive = false;
            this.showLivre = false;
            this.showPrepaCode = false;
            this.showBtn = false;
            this.leleves = [];
            this.currentPage = 0;
            this.getStudents(0, "null");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    onPaginate(e){
      let offset = e.first;
      if(this.showArchive == false && this.showLivre == false && this.showPrepaCode == false){
        this.getStudents(offset, "null");
      }else if(this.showLivre == true){
        this.getStudents(offset, "livret");
      }else if(this.showPrepaCode == true){
        this.getStudents(offset, "prepacode");
      }else if(this.showArchive == true){
        this.getStudents(offset, "archive");
      }
      
    },


    cancelLivreCode(student) {
      window.api
        .patch(
          "/prepacodes/" + student.prepacode[0].id,
          {
            livret: null,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/merge-patch+json",
            },
          }
        )
        .then(() => {
          this.showArchive = false;
          this.showLivre = false;
          this.showPrepaCode = false;
          this.showBtn = false;
          this.leleves = [];
          this.currentPage = 0;
          this.getStudents(0, "null");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onSelected() {
      this.showPaiements = false;
      //this.getPrepacodeById();
    },

    cancelChoice(){
      this.leleves = [];
      this.showBtn = false;
      this.typeaheadKey++;
      this.getStudents(0, "null");
      this.currentPage = 0;
    },

    selectItem(e){
      this.showBtn = true;
      this.getStudents(0, e.id);
    }, 

    searchEleve(e){
      
      if(e.input.length == 3 || e.input.length == 6 || e.input.length == 9 || e.input.length == 12 || e.input.length == 15 || e.input.length == 18 || e.input.length == 21){
          window.api
          .get("/code/name/eleves/search/"+e.input, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            this.leleves = response.data.utilisateurs	;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    showArchives() {
      if (!this.showArchive) {
        this.showArchive = true;
        this.showLivre = false;
        this.showPrepaCode = false;
        //this.students = this.studentsArchive;
        this.getStudents(0, "archive");
        this.currentPage = 0;
      } else {
        this.showArchive = false;
        //this.students = this.studentsUnArchive;
        this.getStudents(0, "null");
        this.currentPage = 0;
      }
    },

    showPrepaCodes() {
      if (!this.showPrepaCode) {
        this.showPrepaCode = true;
        this.showArchive = false;
        this.showLivre = false;
        //this.students = this.studentsPrepaCode;
        this.getStudents(0, "prepacode");
        this.currentPage = 0;
      } else {
        this.showPrepaCode = false;
        //this.students = this.studentsUnArchive;
        this.getStudents(0, "null");
        this.currentPage = 0;
      }
    },

    showLivres() {
      if (!this.showLivre) {
        this.showLivre = true;
        this.showArchive = false;
        this.showPrepaCode = false;
        //this.students = this.studentsLivreCode;
        this.getStudents(0, "livret");
        this.currentPage = 0;
      } else {
        this.showLivre = false;
        //this.students = this.studentsUnArchive;
        this.getStudents(0, "null");
        this.currentPage = 0;
      }
    },

    getStudents(offset, mode) {
      if (this.$store.state.user.role.label == "secretaire") {
        window.api
          .get("/code/user/" + this.$store.state.user.agence.id +"/"+offset+"/"+ mode, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            this.studentsCount = response.data.count;
            this.livretCount = response.data.countLivret;
            this.PrepaCount = response.data.countPrepa;
            this.prepaArchive = response.data.countArchive;
            this.showForm = false;
            this.selectedItem = null;
            // this.showArchive = false;
            // this.showLivre = false;
            // this.showPrepaCode = false;

            if(mode == "archive"){
              this.studentsUnArchive = response.data.student.filter(
                (s) => s.archive == true
              );
            }else{
              this.studentsUnArchive = response.data.student.filter(
                (s) => s.archive == false
              );
            }


            this.studentsLivreCode = response.data.student.filter(
              (s) => s.livret == null
            );

            let tabPrepaNull = response.data.student.filter(
              (s) => s.prepacode == null
            );

            this.studentsPrepaCode = response.data.student.filter(
              (s) => s.prepacode != null
            );
            this.studentsPrepaCode = this.studentsPrepaCode.filter(
              (s) => s.prepacode[0].status == null
            );

            tabPrepaNull.forEach((tab) => {
              this.studentsPrepaCode.push(tab);
            });

            this.studentsLivreCode = response.data.student.filter(
              (s) => s.livret == null
            );

            this.students = this.studentsUnArchive;
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        window.api
          .get("/code/user/0", {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            this.showForm = false;
            this.selectedItem = null;
            this.showArchive = false;
            this.showLivre = false;
            this.showPrepaCode = false;
            this.studentsUnArchive = response.data.student.filter(
              (s) => s.archive == false
            );
            this.studentsArchive = response.data.student.filter(
              (s) => s.archive == true
            );
            this.studentsLivreCode = response.data.student.filter(
              (s) => s.livret == null
            );

            let tabPrepaNull = response.data.student.filter(
              (s) => s.prepacode == null
            );

            this.studentsPrepaCode = response.data.student.filter(
              (s) => s.prepacode != null
            );
            this.studentsPrepaCode = this.studentsPrepaCode.filter(
              (s) => s.prepacode[0].status == null
            );

            tabPrepaNull.forEach((tab) => {
              this.studentsPrepaCode.push(tab);
            });

            this.studentsLivreCode = response.data.student.filter(
              (s) => s.livret == null
            );

            this.students = this.studentsUnArchive;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  
}
</script>
<style scoped>

div.code-agence{
  background-color: #F4F6F9;
  min-height: 100vh;
  padding-bottom: 1rem;
  text-align: left;
}

div.code-content{
  width: 70%;
  margin: auto;
  margin-top: 4rem;
}

div.code-content div.greeting p{
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

div.code-content div.greeting h1{
  font-weight: bold;
}

div.code-content div.informations{
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 24px;
  align-items: start;
  margin-top: 1rem;
}

div.informations div.left{
  display: flex;
  flex-direction: column;
  gap: 20px;
}

div.left div.header-left{
  display: flex;
  justify-content: flex-start;
  gap: 30px;
  margin-bottom: 1rem;
}

div.header-left div.filtre{
  border-radius: 16px;
  padding-bottom: 5px;
  padding-top: 5px;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.livre{
  background-color: #DFEDFF;
}

.livre:hover{
  background-color: #DFEDFF;
  border: 1px solid #325edb;
}

.livre-active{
  border: 1px solid #325edb;
}

.livre span:first-of-type{
  color: #325edb;
  font-weight: bold;
}

.livre span:last-of-type{
  color: #6483D8;
}

.prepa{
  background-color: #fef3c7;
}

.prepa:hover{
  background-color: #fef3c7;
  border: 1px solid #b45309;
}

.prepa-active{
  border: 1px solid #b45309;
}

.prepa span:first-of-type{
  color: #b45309;
  font-weight: bold;
}

.prepa span:last-of-type{
  color: #B36F3B;
}

.archive{
  background-color: #E8ECEF;
}

.archive:hover{
  background-color: #E8ECEF;
  border: 1px solid #64748B;
}

.archive-active{
  border: 1px solid #64748B;
}

.archive span:first-of-type{
  color: #64748B;
  font-weight: bold;
}

.archive span:last-of-type{
  color: #747E8D;
}

div.left div.search-student{
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}

div.left div.search-student button{
  background-color: #f43f5e;
  border: none;
  color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 5px;
}

button.solde-cancel{
  background-color: #f43f5e;
  border: none;
  color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 5px;
}

button.solde-cancel:hover{
  background-color: white;
  border: 1px solid #f43f5e;
  color: #f43f5e;
}

div.left div.search-student button:hover{
  background-color: white;
  border: 1px solid #f43f5e;
  color: #f43f5e;
}

:deep(#typeahead_id_wrapper) {
  width: 80%;
}

:deep(#typeahead_id) {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 10px;
  width: 100%;
}

.simple-typeahead :deep(.simple-typeahead-list) {
  position: absolute;
  z-index: 9999;

  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 300px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
  width: 40%;
}

.simple-typeahead :deep(.simple-typeahead-list-item) {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
}

.simple-typeahead :deep(.simple-typeahead-list-item:hover),
.simple-typeahead :deep(.simple-typeahead-list-item.simple-typeahead-list-item-active) {
  background-color: #f0f4ff;
}

div.left div.tableau{
  width: 100%;
  background-color: white;
}

div.informations div.right{
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  padding: 20px;
}

div.not-select{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.6;
}

div.informations div.right .header-right{
  border-bottom: 1px solid #e2e8f0;
}

div.informations div.right .header-right p:first-of-type{
  font-weight: bold;
  font-size: 20px;
  margin: 0;
}

div.informations div.right .header-right p:last-of-type{
  color: #949faf;
}

div.informations div.right .header-right div.actions{
  display: flex;
  justify-content: flex-start;
  gap: 30px;
  margin-bottom: 1rem;
}

div.informations div.right .header-right div.actions div.contrat{
  padding: 5PX;
  border-radius: 7px;
  font-size: 10px;
  display: flex;
  align-items: center;
}

div.informations div.right .header-right div.actions div.good{
  color: #43B088;
  background-color: #E8F7F1;
}

div.informations div.right .header-right div.actions div.wait{
  color: #B08A43;
  background-color: #F7F2E8;
}

div.informations div.right .header-right div.actions div.not{
  color: #B04343;
  background-color: #F7E8E8;
}

div.informations div.right .header-right div.actions button.solde{
  background-color: #3b82f6;
  color: white;
  padding: 5px;
  font-weight: bold;
  border-radius: 5px;
  border: none;
}

div.informations div.right .header-right div.actions button.solde:hover{
  background-color: white;
  color: #3b82f6;
  border: 1px solid #3b82f6;
}

div.informations div.right .header-right div.actions button.solde:active{
  transform: translateY(-4px);
}

div.informations div.right .content-right p{
  color: #949faf;
  font-weight: bold;
}

div.informations div.right .content-right input{
  width: 100%;
  margin-bottom: 1rem;
  background-color: #F4F6F9;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  padding: 10px;
}

div.informations div.right .content-right div.first{
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  margin-bottom: 1rem;
}

div.informations div.right .content-right div.first button:first-of-type{
  background-color: #3b82f6;
  color: white;
  padding: 5px;
  font-weight: bold;
  border-radius: 5px;
  border: none;
  width: 50%;
}

div.informations div.right .content-right div.first button:first-of-type:hover{
  background-color: white;
  color: #3b82f6;
  border: 1px solid #3b82f6;
}

div.informations div.right .content-right div.first button:first-of-type:active{
  transform: translateY(-4px);
}

div.informations div.right .content-right div.first button:last-of-type{
  background-color: #fff1f2;
  color: #F43F5E;
  padding: 5px;
  font-weight: bold;
  border-radius: 5px;
  border: none;
  width: 40%;
}

div.informations div.right .content-right div.first button:last-of-type:hover{
  background-color: #F43F5E;
  color: #fff1f2;
  border: 1px solid #fff1f2;
}

div.informations div.right .content-right div.first button:last-of-type:active{
  transform: translateY(-4px);
}

div.informations div.right .content-right button.send-id{
  width: 100%;
  background-color: #0EA5E9;
  color: white;
  padding: 5px;
  font-weight: bold;
  border-radius: 5px;
  border: none;
}

button:last-of-type:active{
  transform: translateY(-4px);
}


/* DATATABLE STYLE */

/* Table wrapper */
:deep(.p-datatable) {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 14px;
}

/* Header */
:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
}

/* Rows */
:deep(.p-datatable .p-datatable-tbody > tr) {
  background: #ffffff;
  transition: background 0.15s;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f9fafb;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 18px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
  font-size: 14px;
}

/* Nom en gras */
:deep(.p-datatable .p-datatable-tbody > tr > td:nth-child(2)) {
  font-weight: 600;
}

/* Suppression du style de sélection par défaut */
:deep(.p-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #f0f9ff;
}

/* Bouton "Livre donné ?" (null = orange/jaune) */
:deep(.p-datatable .btn-primary) {
  background: #fef3c7;
  color: #92400e;
  border: none;
  border-radius: 8px;
  padding: 5px 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

:deep(.p-datatable .btn-primary:hover) {
  background: #fde68a;
}

/* Bouton "Livre donné ✓" (non-null = vert) */
:deep(.p-datatable .btn-danger) {
  background: transparent;
  color: #16a34a;
  border: none;
  padding: 5px 0;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

:deep(.p-datatable .btn-danger::after) {
  content: " ✓";
}

/* Paginator */
:deep(.p-paginator) {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 10px 16px;
}

:deep(.p-paginator .p-paginator-page.p-highlight) {
  background: #3b82f6;
  color: #ffffff;
  border-radius: 8px;
  border-color: #3b82f6;
}

:deep(.p-paginator .p-paginator-page),
:deep(.p-paginator .p-paginator-prev),
:deep(.p-paginator .p-paginator-next),
:deep(.p-paginator .p-paginator-first),
:deep(.p-paginator .p-paginator-last) {
  color: #6b7280;
  border: none;
  min-width: 32px;
  height: 32px;
  border-radius: 8px;
}

:deep(.p-paginator .p-paginator-page:hover:not(.p-highlight)),
:deep(.p-paginator .p-paginator-prev:hover),
:deep(.p-paginator .p-paginator-next:hover) {
  background: #f3f4f6;
}


/* ===== RESPONSIVE ===== */
@media (max-width: 1100px) {
  div.code-content {
    width: 90%;
  }
}

@media (max-width: 768px) {
  div.code-content {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    margin-top: 2rem;
  }

  div.code-content div.informations {
    grid-template-columns: 1fr;
    min-width: 0;
  }

  div.informations div.left {
    min-width: 0;
  }

  div.left div.tableau {
    overflow-x: auto;
    min-width: 0;
  }

  div.left div.header-left {
    flex-wrap: wrap;
    gap: 12px;
  }

  :deep(#typeahead_id_wrapper) {
    width: 100%;
  }

  .simple-typeahead :deep(.simple-typeahead-list) {
    width: 100%;
  }
}

@media (max-width: 540px) {
  div.code-content div.greeting h1 {
    font-size: 22px;
  }

  div.left div.header-left {
    gap: 8px;
  }

  div.header-left div.filtre {
    flex: 1 1 calc(50% - 8px);
    min-width: 0;
  }
}
</style>